/* eslint-disable no-undef */
import React from 'react';
import PropTypes from 'prop-types';
import { GoogleMap } from '@react-google-maps/api';

import { useContext } from 'react';
import { Context } from '../../store/context';

function DropPointsMap({ isLoaded, onBoundsChanged }) {
  const { setMap, center, setLastCenter } = useContext(Context);
  const onLoad = React.useCallback(function callback(map) {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(function (position) {
        let initialLocation = new window.google.maps.LatLng(
          position.coords.latitude,
          position.coords.longitude
        );
        map.setCenter(initialLocation);
        setLastCenter({
          lat: initialLocation.lat(),
          lng: initialLocation.lng(),
        });
      });
    } else {
      setLastCenter(center);
    }

    setMap(map);
  });

  const onUnmount = React.useCallback(function callback() {
    setMap(null);
  }, []);

  return (
    <>
      {isLoaded === true ? (
        <GoogleMap
          id="puntos-droop"
          mapContainerStyle={{
            width: '100%',
            height: '100%',
          }}
          zoom={10}
          center={center}
          onLoad={onLoad}
          onUnmount={onUnmount}
          onBoundsChanged={onBoundsChanged}
          options={{ mapId: 'DEMO_MAP_ID' }}
          clickableIcons={false}
        ></GoogleMap>
      ) : null}
    </>
  );
}

DropPointsMap.propTypes = {
  isLoaded: PropTypes.bool,
  dropPoints: PropTypes.array,
  setMapMarkers: PropTypes.func,
  setMap: PropTypes.func,
  onBoundsChanged: PropTypes.func,
};

export default DropPointsMap;
